export enum ModalType {
  ApproveLeadModal,
  ApplicationsUpsellModal,
  AttachmentModal,
  AttachmentsUploader,
  CustomizedBlockedModal,
  BlockedModalFromModule,
  ContactInfoCallModal,
  DeleteAttachmentsModal,
  FiltersSelector,
  ImagesViewer,
  LeaseOptionsModal,
  NotesModal,
  PersonalContactDetailsWarningModal,
  RenterDetailsModal,
  RenterMessagingModal,
  RenterProfileModal,
  RenterScreeningCriteriaModal,
  ReportConversationModal,
  RequestRenterProfileModal,
  SavedReplyModal,
  SendApplicationConfirmationModal,
  SendMessageModal,
  TourSchedulingUpsellModal,
}
